import { render, staticRenderFns } from "./trendingProducts.vue?vue&type=template&id=ce2f2a10&"
import script from "./trendingProducts.vue?vue&type=script&lang=ts&"
export * from "./trendingProducts.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../wellness/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports